import * as React from 'react';
import s from './header-not-logged-in-view.scss';
import { Box, Button, Divider, Popover, TextButton } from 'wix-style-react';
import { ChevronDown } from 'wix-ui-icons-common';
import { useConfigContext } from '../../../../config-context';
import { getCurrentLanguageText } from '../header-desktop-user-details/header-desktop-languages-popover/header-desktop-languages-popover-content/languages';
import { composer } from '../../../../component-decorators/composer';
import { HeaderDesktopLanguagesPopoverContent } from '../header-desktop-user-details/header-desktop-languages-popover/header-desktop-languages-popover-content/header-desktop-languages-popover-content';
export var HeaderNotLoggedInView = composer()
    .withExperiments()
    .compose(function (_a) {
    var signinLink = _a.signinLink, experiments = _a.experiments;
    var shouldShowLanguageSelector = experiments.enabled('specs.marketplace.use-new-marketplace');
    var showIndonesianLanguages = experiments.enabled('specs.marketplace.addIndonesianLanguage');
    // tslint:disable-next-line:react-hooks-nesting
    var locale = useConfigContext().locale;
    // tslint:disable-next-line:react-hooks-nesting
    var _b = React.useState(false), popoverOpen = _b[0], setPopoverOpen = _b[1];
    var flipPopoverOpen = function () {
        setPopoverOpen(!popoverOpen);
    };
    return (React.createElement(Box, { verticalAlign: "middle", className: s.notLoggedIn },
        shouldShowLanguageSelector && (React.createElement(React.Fragment, null,
            React.createElement(Popover, { placement: "bottom", animate: true, appendTo: "scrollParent", onClick: flipPopoverOpen, onClickOutside: flipPopoverOpen, showArrow: true, shown: popoverOpen, theme: "light", dataHook: "languages-popover" },
                React.createElement(Popover.Element, null,
                    React.createElement(TextButton, { skin: "dark", suffixIcon: React.createElement(ChevronDown, null), className: s.languagesButton }, getCurrentLanguageText(locale))),
                React.createElement(Popover.Content, null,
                    React.createElement(HeaderDesktopLanguagesPopoverContent, { isLoggedIn: false, showLanguages: showIndonesianLanguages }))),
            React.createElement(Box, { minHeight: "18px" },
                React.createElement(Divider, { direction: "vertical" })))),
        React.createElement(LoginButton, { signinLink: signinLink })));
});
var LoginButton = composer()
    .withTranslation()
    .compose(function (_a) {
    var t = _a.t, signinLink = _a.signinLink;
    return (React.createElement(Button, { className: s.loginButton, size: "small", priority: "secondary", onClick: function () { return (window.location.href = signinLink); } }, t('standalone.header.login')));
});
//# sourceMappingURL=header-not-logged-in-view.js.map